module.exports = __webpack_public_path__ + "html/profile-project_fb15db0dcc5567d463355ab246e2136a.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/profile-project.html
// module id = Md20
// module chunks = 8